var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "50 0 160 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,180.000000) scale(0.100000,-0.100000)",
    fill: "#575757",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1097 1812 c-15 -16 -17 -46 -17 -213 0 -107 -3 -272 -7 -367 l-6 -173 -97 96 c-54 52 -105 95 -114 95 -23 0 -56 -36 -56 -62 0 -28 296 -317 325 -318 29 0 325 298 325 327 0 23 -34 53 -59 53 -7 0 -55 -40 -105 -90 -51 -49 -95 -90 -99 -90 -4 0 -4 163 -1 363 7 335 6 364 -10 380 -23 22 -59 22 -79 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 1228 c-16 -16 -17 -580 -2 -609 10 -18 28 -19 605 -19 577 0 595 1 605 19 15 29 14 593 -2 609 -18 18 -63 14 -81 -6 -15 -16 -17 -50 -17 -265 l0 -247 -505 0 -505 0 0 248 c0 228 -2 250 -18 265 -22 20 -63 22 -80 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBtn);
export default __webpack_public_path__ + "static/media/download-btn.fec2fc00c4ff2214e97055580c0f6b8d.svg";
export { ForwardRef as ReactComponent };